var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoinSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/checkout/cashSelected"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/checkout/cashSelected2",
    d: "M12 1.99915C13.3132 1.99915 14.6136 2.2578 15.8268 2.76035C17.0401 3.2629 18.1425 3.99949 19.0711 4.92808C19.9997 5.85666 20.7362 6.95905 21.2388 8.17231C21.7413 9.38557 22 10.6859 22 11.9991C22 14.6513 20.9464 17.1948 19.0711 19.0702C17.1957 20.9456 14.6522 21.9991 12 21.9991C10.6868 21.9991 9.38642 21.7405 8.17317 21.2379C6.95991 20.7354 5.85752 19.9988 4.92893 19.0702C3.05357 17.1948 2 14.6513 2 11.9991C2 9.34698 3.05357 6.80344 4.92893 4.92808C6.8043 3.05271 9.34784 1.99915 12 1.99915ZM12 3.99915C9.87827 3.99915 7.84344 4.842 6.34315 6.34229C4.84285 7.84258 4 9.87741 4 11.9991C4 14.1209 4.84285 16.1557 6.34315 17.656C7.84344 19.1563 9.87827 19.9991 12 19.9991C14.1217 19.9991 16.1566 19.1563 17.6569 17.656C19.1571 16.1557 20 14.1209 20 11.9991C20 9.87741 19.1571 7.84258 17.6569 6.34229C16.1566 4.842 14.1217 3.99915 12 3.99915ZM11 16.9991V15.9991H9V13.9991H13V12.9991H10C9.73478 12.9991 9.48043 12.8938 9.29289 12.7063C9.10536 12.5187 9 12.2644 9 11.9991V8.99915C9 8.73393 9.10536 8.47958 9.29289 8.29204C9.48043 8.1045 9.73478 7.99915 10 7.99915H11V6.99915H13V7.99915H15V9.99915H11V10.9991H14C14.2652 10.9991 14.5196 11.1045 14.7071 11.292C14.8946 11.4796 15 11.7339 15 11.9991V14.9991C15 15.2644 14.8946 15.5187 14.7071 15.7063C14.5196 15.8938 14.2652 15.9991 14 15.9991H13V16.9991H11Z",
    fill: "#54AF48"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask22",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 20,
    height: 21
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinSelected);
export default __webpack_public_path__ + "static/media/coinSelected.064c575d.svg";
export { ForwardRef as ReactComponent };